const JobListingMutations = {};

export default JobListingMutations;
